import React from 'react'
import { PageHeading } from '../../../types/cms'
import {Box, Stack, Text} from '../../../vanilla'

interface PageHeaderProps {
  pageHeading: PageHeading | undefined
}

export const PageHeader = ({pageHeading}: PageHeaderProps) => {
    return <Stack>
        {(pageHeading?.heading || pageHeading?.heading2) && (
            <Box marginTop={['0px', '8px']} marginBottom={['24px', '36px']}>
                {pageHeading?.heading && (
                    <Text
                    variant="heading5"
                    lineHeight="normal"
                    textAlign={pageHeading?.textAlignment.toLowerCase() as 'left' | 'right' | 'center'}
                    color="accent0"
                    >
                        {pageHeading.heading}
                    </Text>
                )}
                {pageHeading?.heading2 && (
                    <Text
                    variant="heading1"
                    textAlign={pageHeading?.textAlignment.toLowerCase() as 'left' | 'right' | 'center'}
                    >
                        {pageHeading.heading2}
                    </Text>
                )}
            </Box>
        )}
    </Stack>
}